import createCityFacet from './brand.city';
import createCountryFacet from './brand.country';
import createDistributionInCountriesFacet from './brand.distributionInCountries';
import createDistributionSoughtFacet from './brand.distributionSoughtCountries';
// import createMarketingFacet from './brand.marketingActivities';
import createOfferingsFacet from './brand.offerings';
import createRegionsFacet from './brand.regions';
import createSubeventFacet from './brand.subevent';
import createOpeningHoursFacet from './brand.openingHours';
import createHospitalityOfferings from './brand.hospitalityOfferings';
import createLifestyleOfferings from './brand.lifestyleOfferings';
import createOutdoorExperienceOfferings from './brand.outdoorExperienceOfferings';
import createWineExperienceOfferings from './brand.wineExperienceOfferings';

/**
 * Facet creation. This will be called every time the state or config changes (basically on every rerender).
 * This file can customized per client - just return the filters that are used.
 * @param {object} config Optional configuration from the ProductPage.
 * @param {object} state The current filter state from the productFilterReducer.
 */
export default function createFacets(config, state) {
  return {
    // marketingActivities: createMarketingFacet(config, state),
    event: createSubeventFacet(config, state),
    country: createCountryFacet(config, state),
    region: createRegionsFacet(config, state),
    city: createCityFacet(config, state),
    distributionInCountries: createDistributionInCountriesFacet(config, state),
    distributionSoughtCountries: createDistributionSoughtFacet(config, state),
    offerings: createOfferingsFacet(config, state),
    openingHours: createOpeningHoursFacet(config, state),
    hospitalityOfferings: createHospitalityOfferings(config, state),
    lifestyleOfferings: createLifestyleOfferings(config, state),
    outdoorExperienceOfferings: createOutdoorExperienceOfferings(config, state),
    wineExperienceOfferings: createWineExperienceOfferings(config, state),
  };
}
